var Utility = (function () {
    function Utility() {
    }
    Utility.prototype.generateUUID = function () {
        return this.__s4() + this.__s4() + '-' + this.__s4() + '-' + this.__s4() + '-' + this.__s4() + '-' + this.__s4() + this.__s4() + this.__s4();
    };
    Utility.prototype.__s4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    return Utility;
}());
export { Utility };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/util.ts.pre-build-optimizer.js